import { Pipe, PipeTransform } from '@angular/core';
import { normalizeWebsiteUrl } from '../utils/website-url';

/** Absolute http(s) URL for `<a [href]>` — matches {@link normalizeWebsiteUrl} / school profile website chip behavior. */
@Pipe({
  name: 'websiteHref',
  standalone: true,
})
export class WebsiteHrefPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    return normalizeWebsiteUrl(value) ?? '';
  }
}
